import type { AdComponent } from '../../../../../core/data-sources/content-components/types.js';
import type {
  FrapiListItem,
  FrapiTeaserItem,
} from '../../../../types/frapi-types.js';

import { insertAdsPlacements } from '../../../components/ads/Ad/helpers.js';

export const insertAds = <TItem extends FrapiTeaserItem | FrapiListItem>(
  items: TItem[],
  isMobile: boolean,
): (AdComponent | TItem)[] =>
  insertAdsPlacements(isMobile, items, 'frontpage', 'topplister');
